<template>
  <div>
    <Drawer
      :title="instanceModalTitle"
      v-model="instanceModal"
      width="500"
      :mask-closable="true"
      @on-close="instanceModalCancel">
      <div>
        <Form ref="instanceForm" :model="instanceForm" :label-width="70" :rules="instanceRule">
          <FormItem label="实例名" prop="name">
            <Input v-model="instanceForm.name" clearable/>
          </FormItem>
          <FormItem label="服务器" prop="server">
            <Input v-model="instanceForm.server" clearable/>
          </FormItem>
          <FormItem label="端口" prop="port">
            <Input :number="true" v-model="instanceForm.port" clearable/>
          </FormItem>
          <FormItem label="维护人员" prop="ops_user">
            <Select v-model="instanceForm.ops_user" clearable filterable>
              <Option v-for="item in allUser" :value="item.id" :key="item.id" :label="item.name ? item.name : item.username"></Option>
            </Select>
          </FormItem>
          <FormItem label="所属环境" prop="env">
            <Select v-model="instanceForm.env" clearable filterable>
              <Option v-for="item in allEnv" :value="item.value" :key="item.value" :label="item.label"></Option>
            </Select>
          </FormItem>
          <FormItem label="所属租户" prop="tenant">
            <Select v-model="instanceForm.tenant" clearable filterable multiple>
              <Option v-for="item in tenantList" :value="item.id" :key="item.id" :label="item.name"></Option>
            </Select>
          </FormItem>
          <FormItem label="授权认证" prop="env">
            <RadioGroup v-model="is_auth">
              <Radio label='1'>未开启</Radio>
              <Radio label='2'>已开启</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="is_auth === '2'" label="用户名" prop="username">
            <Input v-model="instanceForm.username" clearable/>
          </FormItem>
          <FormItem v-if="is_auth === '2'" label="密码" prop="password">
            <Input type="password" v-model="instanceForm.password" clearable/>
          </FormItem>
          <FormItem v-if="is_auth === '2'" label="确认密码" prop="repassword">
            <Input type="password" v-model="instanceForm.repassword" clearable/>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="instanceModalCancel">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>
    <Card :style="{height: '100%', minHeight: '280px'}">
      <Row>
        <i-col span="24" :lg="18">
          <Form ref="searchForm" inline :model="searchForm" :label-width="50" onsubmit="return false;">
            <FormItem label="实例名" prop="name">
              <i-input v-model="searchForm.name" placeholder="实例名" style="min-width: 200px;" search
                       @on-enter="getInstances()"></i-input>
            </FormItem>
            <FormItem label="服务器" prop="server">
              <i-input v-model="searchForm.server" placeholder="SERVER" style="min-width: 200px;" search
                       @on-enter="getInstances()"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getInstances()">搜索</Button>
              <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :lg="6" class="align-right">
          <Button @click="addInstance()" type="primary" :style="{marginBottom: '10px' , marginLeft: '10px', float:'rihgt'}" icon="md-add">添加实例
          </Button>
          <Poptip
            confirm
            title="请选择导出选项?"
            @on-ok="exportData(2)"
            @on-cancel="exportData(1)"
            ok-text="当前数据"
            cancel-text="全部数据"
            placement="bottom">
            <Button type="primary" :style="{marginBottom: '10px', marginLeft: '10px',float:'rihgt'}">
              <Icon type="ios-download-outline"></Icon>
              导出数据
            </Button>
          </Poptip>
        </i-col>

      </Row>
      <tables ref="instanceTable" search-place="top" v-model="tableData"
              :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getInstances"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import {getInstanceList, deleteInstance, pushInstance} from '@/api/mongodb'
import {GetALLUsers, getAllTenants} from '@/api/user'
export default {
  name: 'MongoDBInstanceList',
  components: {
    Tables
  },
  data () {
    let that = this
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认输入密码'))
      } else if (value !== this.instanceForm.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }
    return {
      listStyle: {
        width: '400px',
        height: '350px'
      },
      is_auth: '1',
      allUser: [],
      instanceModal: false,
      instanceModalTitle: '添加实例',
      allEnv: [
        {'value': 1, 'label': '生产环境'},
        {'value': 2, 'label': '测试环境'},
        {'value': 3, 'label': '开发环境'}
      ],
      instanceForm: {
        name: '',
        server: '',
        port: '',
        ops_user: '',
        env: '',
        tenant: [],
        username: '',
        password: '',
        repassword: ''
      },
      instanceRule: {
        name: [{required: true, message: '请输入实例名称', trigger: 'blur'}],
        server: [{required: true, message: '请输入服务器地址', trigger: 'blur'}],
        port: [{type: 'number', required: true, message: '请输入端口号', trigger: 'blur'}],
        ops_user: [{type: 'number', required: true, message: '请选择运维DBA', trigger: 'blur'}],
        env: [{type: 'number', required: true, message: '请选择实例所属环境', trigger: 'blur'}],
        tenant: [{required: true, message: '请选择所属租户', type: 'array'}],
        // username: [{required: true, message: '请输入实例用户名', trigger: 'blur'}],
        // password: [{required: true, message: '请输入实例密码', trigger: 'blur'}],
        repassword: [{validator: validatePassCheck, trigger: 'blur'}]
      },
      count: 1,
      size: 15,
      page: 1,
      env: '',
      ordering: null,
      is_superuser: false,
      columns: [
        {title: 'ID', key: 'id', align: 'center', minWidth: 70, sortable: 'custom'},
        {
          title: '实例名',
          key: 'name',
          align: 'center',
          minWidth: 150,
          sortable: 'custom',
          render: (h, param) => {
            return h('router-link', {
              props: {
                to: {name: 'mongodbInstanceInfo', query: {id: param.row.id, name: param.row.name}, params: {server: param.row.server}}
              }
            }, param.row.name)
          }
        },
        {title: '服务器', key: 'server', align: 'center', minWidth: 100, sortable: 'custom'},
        {title: '端口', key: 'port', align: 'center', minWidth: 80},
        {title: '用户名', key: 'username', align: 'center', minWidth: 100},
        {title: 'Master',
          key: 'master',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('div', params.row.master.name)
          }
        },
        {
          title: '环境',
          key: 'env',
          align: 'center',
          minWidth: 100,
          sortable: 'custom',
          render: (h, params) => {
            let envChoices = {
              1: '生产环境',
              2: '测试环境',
              3: '开发环境'
            }
            if (params.row.env) {
              return h('div', envChoices[params.row.env])
            } else {
              return ''
            }
          },
          filters: [
            {
              label: '生产环境',
              value: 1
            },
            {
              label: '测试环境',
              value: 2
            },
            {
              label: '开发环境',
              value: 3
            }
          ],
          filterMultiple: false,
          filterRemote (value, row) {
            if (value.length > 0) {
              that.env = value[0]
            } else {
              that.env = ''
            }
            that.getInstances()
          }
        },
        {
          title: '所属租户',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            let tagList = []
            for (let i in params.row.tenants_name) {
              tagList.push(h('Tag', params.row.tenants_name[i]))
            }
            return h('div', tagList)
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.handleEdit(params)
                    }
                  }
                },
                [
                  h('div', '编辑')
                ]
                ),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleDelete(params)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      marginLeft: '5px'
                    }
                  },
                  [
                    h('div', '删除')
                  ])
                ])

              ])
            }
          }
        }
      ],
      tableData: [],
      searchForm: {
        name: '',
        server: ''
      },
      tenantList: []
    }
  },
  methods: {
    instanceDetail (row) {
      let envChoices = {
        1: '生产环境',
        2: '测试环境',
        3: '开发环境'
      }
      this.$router.push(
        {
          name: 'mongodbInstanceInfo',
          query: {id: row.id, name: row.name},
          params: {host: row.server, port: row.port, ops_user: row.ops_user.username, env: envChoices[row.env]}
        })
    },
    getInstances (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        name: this.searchForm.name,
        server: this.searchForm.server,
        env: this.env,
        tenant_id__in: this.$store.state.user.selTenants
      }
      getInstanceList(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取实例列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取实例列表失败！服务器无响应'
          })
        }
      })
    },
    handleDelete (params) {
      deleteInstance(params.row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getInstances()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    handleSubmit () {
      this.$refs['instanceForm'].validate((valid) => {
        if (valid) {
          pushInstance(this.instanceForm, this.instanceForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getInstances()
            this.instanceFormReset()
            this.instanceModal = false
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    changeSort (column) {
      if (column.order === 'asc') {
        this.ordering = column.key
      } else {
        this.ordering = '-' + column.key
      }

      this.getInstances()
    },
    searchReset () {
      this.searchForm.name = ''
      this.searchForm.server = ''
      this.env = ''
      this.getInstances()
    },
    getUserList () {
      GetALLUsers().then(res => {
        this.allUser = res.data
      })
    },
    addInstance () {
      this.getUserList()
      this.instanceModal = true
    },
    instanceModalCancel () {
      this.instanceFormReset()
      this.instanceModal = false
    },
    instanceFormReset () {
      this.instanceForm.server = ''
      this.instanceForm.port = ''
      this.instanceForm.name = ''
      this.instanceForm.username = ''
      this.instanceForm.password = ''
      this.instanceForm.repassword = ''
      this.instanceForm.ops_user = ''
      this.instanceForm.env = ''
      this.instanceForm.tenant = []
    },
    handleEdit: function (params) {
      this.getUserList()
      this.instanceForm.id = params.row.id
      this.instanceForm.server = params.row.server
      this.instanceForm.port = params.row.port
      this.instanceForm.name = params.row.name
      this.instanceForm.username = params.row.username
      params.row.username ? this.is_auth = '2' : this.is_auth = '1'
      this.instanceForm.password = ''
      this.instanceForm.repassword = ''
      this.instanceForm.ops_user = params.row.ops_user.id
      this.instanceForm.env = params.row.env
      this.instanceForm.tenant = params.row.tenant
      this.instanceModal = true
    },
    exportData (type) {
      if (type === 1) {
        this.$refs.instanceTable.exportCsv({
          filename: `allInstance-${(new Date()).valueOf()}.csv`
        })
      } else if (type === 2) {
        this.$refs.instanceTable.exportCsv({
          filename: `currentInstance-${(new Date()).valueOf()}.csv`,
          original: false
        })
      }
    },
    getTenants () {
      getAllTenants().then(res => {
        this.tenantList = res.data
      })
    }
  },
  mounted: function () {
    this.getInstances()
    this.getTenants()
  }
}
</script>
